export const SET_URLS = 'SET_URLS'
export const SET_SUCCESS = 'SET_SUCCESS'
export const BUTTON_LOADING = 'BUTTON_LOADING'
export const RESET_FORM = 'RESET_FORM'
